import { Flex } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { getFormValues } from 'redux/DataImportSlice';
import { fetchBlock } from 'redux/PlanPageSlice';

import ActionStepSyncOptions from '../ActionStepSyncOptions';

import DataStepsFourth from './DataStepsFourth';
import DataStepsOne from './DataStepsOne';
import DataStepsFive from './DataStepsFive';
import DataStepsThree from './DataStepsThree';
import DataStepsTwo from './DataStepsTwo';
import SelectDimensionColumn from './SelectDimensionColumn';

interface Properties {
  setHelpModalSeleceted: any;
}
const DataStepsForm = ({ setHelpModalSeleceted }: Properties) => {
  const dispatch: any = useDispatch();
  const getFormValue = useSelector(getFormValues);
  const activeActionStep = useSelector((state: any) => state.dataImportSlice.actionSteps);
  const blockId = getFormValue?.blockId;
  const isDataOrForecast = getFormValue?.dataType === '2' || getFormValue?.dataType === '3';
  const actionType = getFormValue?.dataType === '3' ? 'forecast' : 'data';
  const isMultipleIndicatorImport = getFormValue?.importIndicatorType === '2';
  const isSinglePeriod = getFormValue?.dataPeriod === '1';
  const isMultiplePeriod = getFormValue?.dataPeriod === '2';
  const isRowIndicatorMapping = getFormValue?.multipleIndicatorsType === 'row';
  const isRowTimeMapping = getFormValue?.selectedTimePeriod === 'row';
  const shouldShowMultipleIndicatorDetails =
    isMultipleIndicatorImport &&
    ((isSinglePeriod && activeActionStep >= 5 && activeActionStep <= 7) ||
      (isMultiplePeriod &&
        (activeActionStep === 6 ||
          activeActionStep === 7 ||
          (isRowIndicatorMapping && isRowTimeMapping && activeActionStep === 8))));

  useEffect(() => {
    if (blockId) {
      dispatch(fetchBlock(blockId));
    }
  }, [blockId]);

  return (
    <Flex w={'full'} align={'center'}>
      {isDataOrForecast && activeActionStep === 2 && (
        <DataStepsOne setHelpModalSeleceted={setHelpModalSeleceted} />
      )}

      {isDataOrForecast && getFormValue?.dataPeriod === '1' && activeActionStep === 3 && (
        <DataStepsThree />
      )}

      {isDataOrForecast && getFormValue?.dataPeriod === '2' && activeActionStep === 3 && (
        <DataStepsTwo setHelpModalSeleceted={setHelpModalSeleceted} />
      )}

      {isDataOrForecast && getFormValue?.dataPeriod === '2' && activeActionStep === 4 && (
        <DataStepsThree />
      )}

      {isDataOrForecast &&
        getFormValue?.dataPeriod === '1' &&
        activeActionStep === 4 &&
        getFormValue?.importIndicatorType === '1' && (
          <SelectDimensionColumn getFormValue={getFormValue} />
        )}
      {isDataOrForecast &&
        getFormValue?.dataPeriod === '1' &&
        activeActionStep === 5 &&
        getFormValue?.importIndicatorType === '1' && (
          <ActionStepSyncOptions actionType={actionType} />
        )}
      {isDataOrForecast &&
        getFormValue?.dataPeriod === '2' &&
        activeActionStep === 5 &&
        getFormValue?.importIndicatorType === '1' && (
          <SelectDimensionColumn getFormValue={getFormValue} />
        )}
      {isDataOrForecast &&
        getFormValue?.dataPeriod === '2' &&
        activeActionStep === 6 &&
        getFormValue?.importIndicatorType === '1' && (
          <ActionStepSyncOptions actionType={actionType} />
        )}

      {isDataOrForecast &&
        getFormValue?.dataPeriod === '1' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 4 && <DataStepsFourth />}

      {isDataOrForecast &&
        getFormValue?.dataPeriod === '2' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 5 && <DataStepsFourth />}

      {isDataOrForecast && shouldShowMultipleIndicatorDetails && <DataStepsFive />}
    </Flex>
  );
};

export default DataStepsForm;
